import React, { useEffect, useState } from "react";
import { adminUserService } from "../../services/adminUserService";
import { Link } from "react-router-dom";

export const AdminUserList: React.FC = () => {
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      try {
        const res = await adminUserService.getAll();
        if (mounted) setUsers(res);
      } catch (err) {
        console.error(err);
        alert("Failed to load users");
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm("Delete this user? This cannot be undone.")) return;
    try {
      await adminUserService.remove(id);
      setUsers((u) => u.filter((x) => x.id !== id));
      alert("User deleted.");
    } catch (err) {
      console.error(err);
      alert("Failed to delete user.");
    }
  };

  return (
    <div className="admin-container">
      <h2 className="admin-header">Admin Users</h2>
      <Link to="/admin/users/new" className="adminAddButton">Add Admin</Link>
      <table className="table">
        <thead>
          <tr><th>Name</th><th>Email</th><th>Role</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id}>
              <td>{u.name}</td><td>{u.email}</td><td>{u.role}</td>
              <td>
                <Link to={`/admin/users/view/${u.id}`}>View</Link>{" | "}
                <Link to={`/admin/users/edit/${u.id}`}>Edit</Link>{" | "}
                <button type="button" onClick={() => handleDelete(u.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUserList